export const selectShippingConfirmation = (state) =>
    state.views.shippingCheckout.shippingConfirmation;

export const selectShippingCheckout = (state) => state.views.shippingCheckout;

export const selectShipping = (state) => state.views.shippingCheckout.shipping;

export const selectItemWithoutShipment = (state) =>
    state.views.shippingCheckout.itemWithoutShipment;

export const selectShipment = (state, shipmentId) =>
    state.views.shippingCheckout?.shipments?.find(
        (shipment) => shipment.shipmentId === shipmentId
    );

export const selectShippingPayment = (state) =>
    state.views.shippingCheckout.payment;

export const selectCheckoutSummary = (state) =>
    state.views.shippingCheckout.checkoutSummary;

export const selectSellerPhoneNumber = (state) =>
    state.views.shippingCheckout.sellerPhoneNumber;
